import { Component } from '@angular/core';

@Component({
  selector: 'empathy-ai-chat-description',
  templateUrl: 'ai-chat-description.component.html',
  styleUrls: ['./ai-chat-description.component.scss']
})
export class AIChatDescriptionComponent {}
